import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ModalPortal from 'components/ModalPortal';
import MessageModal from 'components/MessageModal';

const ConfirmModal = ({ className, onClose, ...messageProps }) => {
	const portalClassName = cx('modal-center', className || 'modal-small');

	return (
		<ModalPortal className={portalClassName} onClose={onClose}>
			<MessageModal {...messageProps} />
		</ModalPortal>
	);
};

ConfirmModal.propTypes = {
	className: PropTypes.string,
	onClose: PropTypes.func,
};

export default ConfirmModal;
